export var FocusACCTypes;
(function (FocusACCTypes) {
    FocusACCTypes["Cascade"] = "acc-cascade";
    FocusACCTypes["Edit"] = "acc-edit";
    FocusACCTypes["Grafos"] = "acc-grafos";
    FocusACCTypes["CDM"] = "acc-cdm";
    FocusACCTypes["NDM"] = "acc-ndm";
    FocusACCTypes["Ebro"] = "acc-ebro";
    FocusACCTypes["EditOut"] = "acc-edit-out";
    FocusACCTypes["Pregrafos"] = "acc-pregrafos";
    FocusACCTypes["Stdout"] = "acc-stdout";
    FocusACCTypes["Ascii"] = "acc-ascii";
    FocusACCTypes["RTFIn"] = "acc-rtf-in";
    FocusACCTypes["RTFOut"] = "acc-rtf-out";
    FocusACCTypes["SIF"] = "acc-sif";
    FocusACCTypes["RViewer"] = "acc-rviewer";
    FocusACCTypes["PDF"] = "acc-pdf";
    FocusACCTypes["HTML"] = "acc-html";
    FocusACCTypes["EXCEL"] = "acc-excel";
    FocusACCTypes["DB"] = "acc-db";
})(FocusACCTypes || (FocusACCTypes = {}));
//# sourceMappingURL=Panel.js.map